window.addEventListener("DOMContentLoaded", function() {
  if (kigui.layout.header.msg.close.getElement() !== null) {
    kigui.layout.header.msg.close
      .getElement()
      .addEventListener("click", function() {
        kigui.layout.header.msg.hide();
      });
  }
  var b = document.querySelectorAll(".kigui-o-f_f");
  if (b !== null) {
    var a;
    for (a = 0; a < b.length; a++) {
      b[a].onclick = function() {
        this.classList.toggle("kigui-o-f_h");
      }; 
    }
  }
});
var kigui = {
  layout: {
    body: {
      element: null,
      getElement: function() {
        if (this.element === null) {
          this.element = document.querySelector(".kigui-l-b");
        }
        return this.element;
      },
      enableScroll: function() {
        kigui.layout.body.getElement().classList.remove("kigui-l-b_h");
      },
      disableScroll: function() {
        kigui.layout.body.getElement().classList.add("kigui-l-b_h");
      }
    },
    header: {
      msg: {
        text: {
          element: null,
          getElement: function() {
            if (this.element === null) {
              this.element = document.querySelector(".kigui-l-h-m-t");
            }
            return this.element;
          },
          setText: function(b) {
            var a = kigui.layout.header.msg.text.getElement();
            if (a !== null) {
              a.innerText = b;
            }
          }
        },
        close: {
          element: null,
          getElement: function() {
            if (this.element === null) {
              this.element = document.querySelector(".kigui-l-h-m-c");
            }
            return this.element;
          }
        },
        code: "",
        element: null,
        getElement: function() {
          if (this.element === null) {
            this.element = document.querySelector(".kigui-l-h-m");
          }
          return this.element;
        },
        show: function() {
          var a = this.getElement();
          if (a !== null) {
            a.classList.add("kigui-l-h-m_o");
          }
          if (
            kigui.layout.header.getElement().classList.contains("kigui-l-h_f")
          ) {
            kigui.layout.others.msg.getElement().classList.add("kigui-l-h-m_o");
          }
        },
        hide: function() {
          var a = this.getElement();
          if (a !== null) {
            a.classList.remove("kigui-l-h-m_o");
          }
          if (
            kigui.layout.header.getElement().classList.contains("kigui-l-h_f")
          ) {
            kigui.layout.others.msg
              .getElement()
              .classList.remove("kigui-l-h-m_o");
          }
          if (typeof Storage !== "undefined") {
            localStorage.setItem("msgCode", kigui.layout.header.msg.code);
          }
        },
        toggle: function() {
          var a = this.getElement();
          if (a !== null) {
            a.classList.toggle("kigui-l-h-m_o");
          }
        },
        setCode: function(a) {
          this.code = a;
        },
        getCode: function() {
          return this.code;
        },
        loadCode: function() {
          return localStorage.getItem("msgCode");
        },
        isNewMsg: function() {
          return this.getCode() !== this.loadCode();
        },
        setEvent: function(c, b, a) {
          this.text.setText(c);
          this.setCode(b);
          if (a === true) {
            window.addEventListener("load", function() {
              if (kigui.layout.header.msg.isNewMsg()) {
                kigui.layout.header.msg.show();
              }
            });
          } else {
            window.addEventListener("load", function() {
              kigui.layout.header.msg.show();
            });
          }
        }
      },
      element: null,
      getElement: function() {
        if (this.element === null) {
          this.element = document.querySelector(".kigui-l-h");
        }
        return this.element;
      },
      setShadow: function(a) {
        a
          ? this.getElement().classList.add("kigui-l-h_s")
          : this.getElement().classList.remove("kigui-l-h_s");
      },
      setFixed: function(a) {
        a
          ? this.getElement().classList.add("kigui-l-h_f")
          : this.getElement().classList.remove("kigui-l-h_f");
      }
    },
    sidemenu: {
      element: null,
      getElement: function() {
        if (this.element === null) {
          this.element = document.querySelector(".kigui-l-s");
        }
        return this.element;
      },
      show: function() {
        this.getElement().classList.add("kigui-l-s_o");
      },
      hide: function() {
        this.getElement().classList.remove("kigui-l-s_o");
      },
      eventMenuOpen: function() {
        kigui.layout.sidemenu.show();
        kigui.layout.body.disableScroll();
        kigui.layout.others.pageCover.show();
      },
      eventMenuClose: function() {
        kigui.layout.sidemenu.hide();
        kigui.layout.body.enableScroll();
        kigui.layout.others.pageCover.hide();
      }
    },
    contents: {
      element: null,
      getElement: function() {
        if (this.element === null) {
          this.element = document.querySelector(".kigui-l-c");
        }
        return this.element;
      }
    },
    others: {
      msg: {
        element: null,
        getElement: function() {
          if (this.element === null) {
            this.element = document.querySelector(".kigui-l-o-m");
          }
          return this.element;
        }
      },
      pageCover: {
        element: null,
        getElement: function() {
          if (this.element === null) {
            this.element = document.querySelector(".kigui-l-o-p");
          }
          return this.element;
        },
        show: function() {
          if (this.getElement() !== null) {
            this.getElement().classList.add("kigui-l-o-p_o");
          }
        },
        hide: function() {
          if (this.getElement() !== null) {
            this.getElement().classList.remove("kigui-l-o-p_o");
          }
        }
      }
    }
  }
};

export default kigui;
